module.exports = __webpack_public_path__ + "static/media/2017-06-23_137.011fd95d.JPG";